import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface NewsContent {
  name: string;
  api_token: string;
}

export interface NewsContentDetaiInfor {
  errors: unknown;
  NewsContent: NewsContent;
  isAuthenticated: boolean;
}

@Module
export default class NewsContentDetail
  extends VuexModule
  implements NewsContentDetaiInfor
{
  errors = {};
  NewsContent = {} as NewsContent;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get NewsContentDetail() {
    return this.newsContentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.NEWS_CONTENT_DETAIL_DATA](NewsContent) {
    this.newsContentDetailData = NewsContent;
  }
  @Action
  [Actions.NEWS_CONTENT_DETAIL](payload) {
    return ApiService.getDataDetail("/news", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.NEWS_CONTENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
